import moment from 'moment';
import HomeActionType from '../../common/HomeActionType';
import LocalStorage from '../../common/LocalStorage';

const NUM_DAYS_EXPIRY = {
  broadbandcompare: 90,
  ratebroker: 7
};

const storePartner = (name, leadKey) => {
  const daysUntilExpiry = NUM_DAYS_EXPIRY[name.toLowerCase()];
  const expiry = moment().add(daysUntilExpiry, 'days').valueOf();
  LocalStorage.save('partner', { name, leadKey }, expiry);
};

const updateAction = (action) => {
  if (action.partner.name) {
    storePartner(action.partner.name, action.partner.leadKey);

    return action;
  }

  return {
    ...action,
    partner: LocalStorage.get('partner') || { name: '', leadKey: '' }
  };
};

const PartnerMiddleware = () => next => action =>
  (action.type === HomeActionType.STORE_PARTNER)
    ? next(updateAction(action))
    : next(action);

export default PartnerMiddleware;



/** WEBPACK FOOTER **
 ** ./src/redux/middleware/PartnerMiddleware.js
 **/